import React from 'react';

import { Box } from '@chakra-ui/react';
import { REVIEW_FORM_KEYS } from 'reducers/reviewFormSlice';
import useReviewResultParams from 'screens/performanceReview/hooks/useReviewResultParams';

import { TagColored } from 'uiToolkitV1/Tag';

import { useCompetencyFormData } from '../CompetencyForm/hooks/dataHooks';
import { useGoalFormData } from '../GoalForm/hooks/dataHooks';
import { useOverallQuestionsFormData } from '../OverallQuestionsForm/hooks/dataHooks';
import REVIEW_FORM_TYPES from '../Sidebar/common/REVIEW_FORM_TYPES';
import { useReviewFormSidebarData } from '../Sidebar/hooks/dataHooks';
import { getHardcodedText } from '../newFormComponents/OverallFormScore';

export const OverallFormScoreText = ({ reviewFormKey = null }) => {
  const { employeeId, providerId, reviewId } = useReviewResultParams();

  const reviewForm = reviewFormKey;

  const { data: goalFormData, isLoading: isLoadingGoalFormData } = useGoalFormData({
    employeeId,
    providerId,
    reviewId,
  });
  const { data: competencyFormData, isLoading: isLoadingCompetencyFormData } = useCompetencyFormData({
    employeeId,
    providerId,
    reviewId,
  });
  const { data: overallFormData, isLoading: isLoadingOverallFormData } = useOverallQuestionsFormData({
    employeeId,
    providerId,
    reviewId,
  });

  const { averageGoalRating } = goalFormData ?? {};
  const goalRatingText = getHardcodedText(averageGoalRating);

  const { averageCompetencyRating } = competencyFormData ?? {};
  const competencyRatingText = getHardcodedText(averageCompetencyRating);

  const { averageQNARating } = overallFormData ?? {};
  const qnaRatingText = getHardcodedText(averageQNARating);

  let ratingText = '';
  if (reviewForm === REVIEW_FORM_KEYS.GOAL) {
    ratingText = goalRatingText;
  } else if (reviewForm === REVIEW_FORM_KEYS.COMPETENCY) {
    ratingText = competencyRatingText;
  } else if (reviewForm === REVIEW_FORM_KEYS.QNA) {
    ratingText = qnaRatingText;
  }

  if (!reviewFormKey || isLoadingGoalFormData || isLoadingCompetencyFormData || isLoadingOverallFormData) return null;

  return ratingText;
};

// this components should be removed in future,
// OverallFormScore should be made hook agnostic, so that it shows rating without data coupled within it.

export const OverallResultScore = ({ reviewForm }) => {
  const { reviewId, employeeId, providerId } = useReviewResultParams();

  const { isShowQNARating, isShowGoalRating, isShowCompetencyRating } = useReviewFormSidebarData({
    reviewId,
    employeeId,
    providerId,
  });

  if (reviewForm === REVIEW_FORM_KEYS.GOAL && !isShowGoalRating) {
    return null;
  }
  if (reviewForm === REVIEW_FORM_KEYS.COMPETENCY && !isShowCompetencyRating) {
    return null;
  }
  if (reviewForm === REVIEW_FORM_KEYS.QNA && !isShowQNARating) {
    return null;
  }

  if (!reviewForm) return null;

  return (
    <Box ml="auto">
      <TagColored color="black">
        {REVIEW_FORM_TYPES[reviewForm].titlePlural} Overall Score: <OverallFormScoreText reviewFormKey={reviewForm} />
      </TagColored>
    </Box>
  );
};
